<template>
  <div>
    <PCNavbar selectIndex="1-1" style="background: #ececec;"/>
    <MobileNavBar :currentActive="1" />
    <Check v-show="checkIsVisible"/>
    <SalesLc v-show="salesIsVisible"/>
    <Question v-show="questionIsVisible"/>
    <UseWh v-show="whIsVisible"/>
    <!--  页脚 -->
    <Footer/>
  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/indexDetail.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import Footer from '@/views/home/callme/footerIndex.vue'
import Check from "@/views/business/portal_check/check.vue";
import SalesLc from "@/views/business/portal_check/sales_lc.vue";
import Question from "@/views/business/portal_check/question.vue";
import UseWh from "@/views/business/portal_check/wh.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Check,
    SalesLc,
    Question,
    UseWh,
    Footer
  },
  data(){
    return{
      //跳转页面类型
      type:"",
      checkIsVisible: true,//真伪查询是否显示
      salesIsVisible: false,//售后流程是否显示
      questionIsVisible: false,//常见问题是否显示
      whIsVisible: false,//使用维护是否显示
    }
  },
  watch:{
    '$route.query.type': {
      immediate: true, // 初始化时也执行
      handler(newVal) {
        if (newVal) {
          this.onchangeType(newVal);
        } else {
          this.checkIsVisible = true;
        }
      },
    }
  },
  methods:{
    onchangeType(newVal) {
      if (newVal === 'sales') {
        this.checkIsVisible = false;
        this.salesIsVisible = true;
        this.questionIsVisible = false;
        this.whIsVisible = false;
      } else if(newVal === 'check'){
        this.checkIsVisible = true;
        this.salesIsVisible = false;
        this.questionIsVisible = false;
        this.whIsVisible = false;
      }else if(newVal === 'question'){
        this.checkIsVisible = false;
        this.salesIsVisible = false;
        this.questionIsVisible = true;
        this.whIsVisible = false;
      }else if(newVal === 'wh'){
        this.checkIsVisible = false;
        this.salesIsVisible = false;
        this.questionIsVisible = false;
        this.whIsVisible = true;
      }else{
        this.checkIsVisible = true;
        this.salesIsVisible = false;
        this.questionIsVisible = false;
        this.whIsVisible = false;
      }
    }
  }
}
</script>

<style>
</style>